import React, { useState } from "react";
import { FooterContainer, FooterLink, FooterItemContent, ContainerInModal } from "./Footer.style";
import { FooterItem, FooterContent } from "../../types";
import ReactModal from "react-modal";
import Icon from "../../icons";

interface Props {
  itemList: FooterItem[];
}

const Footer: React.FC<Props> = (props) => {
  const [modalContent, setModalContent] = useState<string | undefined>();
  const onClickContentItem = (item: FooterContent) => () => {
    setModalContent(item.content);
  };
  return (
    <FooterContainer>
      {props.itemList.map((item) => {
        if (item.type === "link")
          return (
            <FooterLink href={item.link} target="_blank">
              {item.text}
            </FooterLink>
          );
        else return <FooterItemContent onClick={onClickContentItem(item)}>{item.text}</FooterItemContent>;
      })}
      <ReactModal
        style={{
          overlay: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
          content: {
            position: "unset",
            maxWidth: "70vw",
            maxHeight: "90vh",
          },
        }}
        isOpen={modalContent !== undefined}
        onRequestClose={() => setModalContent(undefined)}
      >
        <ContainerInModal>
          <Icon
            name="cancel"
            style={{ alignSelf: "flex-end", cursor: "pointer" }}
            fontSize={"2em"}
            onClick={() => setModalContent(undefined)}
          />
          <div
            style={{ paddingRight: "3em", paddingLeft: "3em" }}
            dangerouslySetInnerHTML={{ __html: modalContent || "" }}
          />
        </ContainerInModal>
      </ReactModal>
    </FooterContainer>
  );
};

export default Footer;
